'use client';

import { useState, useRef, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCheck } from '@awesome.me/kit-94e593bf23/icons/sharp/regular';
const CategoryDropdown = ({
  categories,
  selected_value,
  selectedCategory,
  selectCategoryFunction,
  identifier,
  label
}) => {
  const [visibilityTimer, setVisibilityTimer] = useState({});
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const clikcRef = useRef(null);
  const handleOutSideClickRef = useRef(null);
  const closeDropdownWithPause = useCallback(() => {
    if (handleOutSideClickRef.current) {
      window.removeEventListener("mousedown", handleOutSideClickRef.current);
    }
    setOpen(false);
    setVisibilityTimer(setTimeout(() => {
      setVisible(false);
    }, 700));
  }, []);
  const closeDropdown = useCallback(() => {
    if (handleOutSideClickRef.current) {
      window.removeEventListener("mousedown", handleOutSideClickRef.current);
    }
    setOpen(false);
    setVisible(false);
  }, []);
  const handleOutSideClick = useCallback(event => {
    if (!clikcRef.current?.contains(event.target)) {
      event.stopPropagation();
      event.preventDefault();
      closeDropdownWithPause();
    }
  }, [closeDropdownWithPause]);

  // Store the function in a ref so removeEventListener can access the same reference
  handleOutSideClickRef.current = handleOutSideClick;
  const openDropdown = useCallback(() => {
    clearTimeout(visibilityTimer);
    if (open) {
      closeDropdown();
    } else {
      setOpen(true);
      setVisible(true);
    }
    window.addEventListener("mousedown", handleOutSideClick);
  }, [open, visibilityTimer, closeDropdown, handleOutSideClick]);
  const handleOptionSelection = (category, index) => {
    selectCategoryFunction(category, index);
    closeDropdown();
  };
  const selectedCategoryRenderer = category_0 => {
    return <>
                <span className="">{category_0.category_name}</span>
            </>;
  };
  const categoryRenderer = (category_1, selectedCategory_0 = false) => {
    return <div className="flex justify-between items-center w-full">
                <span className={`${category_1.category_id == selectedCategory_0.category_id ? '' : ''}`}>
                    {category_1.category_name}
                </span>
                {selectedCategory_0.category_id == category_1.category_id && <FontAwesomeIcon icon={faCheck} className={`ml-3 inline text-xs text-lime-600`} />}
            </div>;
  };
  return <div ref={clikcRef} className={`hidden group relative border-b border-gray-20 hover:border-primary h-8 z-auto mb-6`}>
            <label onClick={openDropdown} className={`absolute bottom-0 left-0 mb-[.1rem] flex items-center justify-between w-full transition-all duration-100 ${open ? 'z-20 text-primary' : ''}`}>
                <span className={`group-hover:indent-1 transition-all duration-500 text-xs ${open ? 'indent-1' : ''}`}>
                    {selectedCategory && selected_value ? <>
                            <label htmlFor={identifier} className="absolute -top-[.9rem] indent-0 text-4xs capitalize text-light">{label}</label>
                            {selectedCategoryRenderer ? selectedCategoryRenderer(selectedCategory) : categoryRenderer(selectedCategory)}
                        </> : <label htmlFor={identifier} className="text-sm">{selectedCategory.category_name}</label>}
                </span>
                <FontAwesomeIcon icon={faChevronRight} size="2xs" className={`duration-500 transition-all ${open ? 'rotate-90 text-primary' : 'text-light-3 group-hover:text-main'}`} />
            </label>
            <div id={identifier} className={`absolute top-8 w-full py-1 drop-shadow-lg transition-all duration-400 overflow-y-scroll overflow-x-hidden max-h-[350px] ${open ? 'z-10 opacity-1' : 'opacity-0 h-8'} ${visible ? 'visible' : 'invisible hidden'}`}>
                {categories && categories.map((category_2, index_0) => <button type="button" key={index_0} onClick={() => handleOptionSelection(category_2, index_0)} className={`flex justify-between items-center w-full py-2 px-2 bg-gray-2 bg-white border-b border-gray-20 text-left text-sm capitalize whitespace-nowrap hover:bg-gray-5`}>
                        <>{categoryRenderer(category_2, selectedCategory)}</>
                    </button>)}
            </div>
        </div>;
};
export default CategoryDropdown;